import { PropsWithChildren } from "react";
import { Colour } from "../../Variables";

export type CardDividerProps = {
    title: string,
    icon: string
}

export function CardDivider(props: PropsWithChildren<CardDividerProps>) {
    return (
        <div className={`card-divider no-highlight`}>
            {props.icon && <i className={props.icon}></i>} {props.title}
            <hr className="ShortBlock"/>
        </div>
    );
}